
import Modal from 'react-bootstrap/Modal'
import '../css/VerticalCenterModal.css'
import { DateFormat } from '../utils/Utils'
function VerticalCenterModal(props) {

    const bodyItem = (e) => {
      const retorno = e.map((x) => {
        return (
          <li key={x.evento} className="event">
            <h3>{DateFormat(x.dataHora)}</h3>
            <h6>{x.evento}</h6>
            <p>{x.detalhe}</p>
          </li>
        );
      })
      return (
        <div className="row">
          <div id="content">
            <ul className="timeline">{retorno}</ul>
          </div>
        </div>
      );
    }

    const body = (e) => {
      const retorno = e.map((x) => {
        return (
          <>
          <div className="row">
            <div className="col-12 visual-identity">
              <img className="visual-identity-img" src={x.imagemTransportador}/>
            </div>
            <div className="col-6">
              <h5 className="card-title">Transportador</h5>
              <p className="card-description">{x.transportador}</p>
            </div>
            <div className="col-6">
              <h5 className="card-title">Método de entrega</h5>
              <p className="card-description">{x.metodoEnvio}</p>
            </div>
          </div>
          {bodyItem(x.historicoEventos)}
          </>
        );
      })

      return (
        <>{retorno}</>
      ); 
    }
    

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Detalhes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                          {body(props.eventos)}
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  export default VerticalCenterModal;